import React, { useReducer } from 'react';
import { BrowserRouter as Router, Route, Redirect } from 'react-router-dom';

import './App.scss';
import { AnimatedSwitch } from 'react-router-transition';

import Station from 'components/pages/Station';
import OrderType from 'components/pages/OrderType';
import Skill from 'components/pages/Skill';
import Cond from 'components/pages/Cond';
import Info from 'components/pages/Info';
import Conf from 'components/pages/Conf';
import Thanks from 'components/pages/Thanks';

import {
  STATION_URL,
  TYPE_URL,
  SKILL_URL,
  COND_URL,
  INFO_URL,
  CONF_URL,
  THANKS_URL,
  FIRST_URL,
  // debugInitialState,
} from 'utils/constant';

import AppContext from 'fluxes/context';
import AppReducer from 'fluxes/reducer';

const App = () => {

  const initialState = {
    ekiName: '',
    ekiCd: '',
    moveTypeCd: '',
    moveTime: '',
    moveTimeFromBusStop: '',
    physicalCare: [],
    lifeSupport: [],
    otherWorkText: '',
    experience: '01',
    qualification: [],
    qualificationText: '',
    fromDate: null,
    pendingFromDateFlag: false,
    toDate: null,
    pendingToDateFlag: false,
    workStyle: '02', // シフト勤務
    dayOfTheWeek: [ '1', '2', '3', '4', '5' ],
    workStyleKbn: [],
    earlyShiftStartHour: '09', // 早番
    earlyShiftStartMin: '00',
    earlyShiftEndHour: '18',
    earlyShiftEndMin: '00',
    earlyShiftRestTime: '60',
    dayShiftStartHour: '09', // 日勤
    dayShiftStartMin: '00',
    dayShiftEndHour: '18',
    dayShiftEndMin: '00',
    dayShiftRestTime: '60',
    lateShiftStartHour: '09', // 遅番
    lateShiftStartMin: '00',
    lateShiftEndHour: '18',
    lateShiftEndMin: '00',
    lateShiftRestTime: '60',
    nightShiftStartHour: '09', // 夜勤
    nightShiftStartMin: '00',
    nightShiftEndHour: '18',
    nightShiftEndMin: '00',
    nightShiftRestTime: '60',
    fixedStartHour: '09', // 固定勤務
    fixedStartMin: '00',
    fixedEndHour: '18',
    fixedEndMin: '00',
    fixedRestTime: '60',
    canCommuteByCar: '', // 車通勤
    minBusinessDay: '5',
    maxBusinessDay: '5',
    hourSalary: '',
    suggestHourSalary: '',
    freeComment: '',
    corpName: '',
    facilityName: '',
    facilityType: [],
    capacity: '',
    userName: '',
    tel: '',
    email: '',
    emailConf: '',
    zip: '',
    municipality: '',
    houseNumber: '',
    isModify: false,
    validMap: {
      [STATION_URL]: false,
      [TYPE_URL]: false,
      [SKILL_URL]: false,
      [COND_URL]: false,
      [INFO_URL]: false,
      [CONF_URL]: false,
    },
    isRegistered: false,
    hourSalaryLoading: true,
    hasQualificationText: false,
    lpMode: false,
    lpID: 'init',
    lpOrigin: '',
  };
  
  // const [ state, dispatch ] = useReducer(AppReducer, debugInitialState);
  const [ state, dispatch ] = useReducer(AppReducer, initialState);

  const NotFound = () => <Redirect to={FIRST_URL} />;

  const routes = [
    { path: STATION_URL, Component: Station },
    { path: TYPE_URL, Component: OrderType },
    { path: SKILL_URL, Component: Skill },
    { path: COND_URL, Component: Cond },
    { path: INFO_URL, Component: Info },
    { path: CONF_URL, Component: Conf },
    { path: THANKS_URL, Component: Thanks },
  ];

  // console.log({ state });

  const transStyle = {
    atEnter: { right: 0, opacity: 0.5 },
    atLeave: { right: 1000, opacity: 0 },
    atActive: { right: 0, opacity: 1 },
  };
  return (
    <div className="App">
      <AppContext.Provider value={{ state, dispatch }}>
        <Router>
          <AnimatedSwitch
            atEnter={transStyle.atEnter}
            atLeave={transStyle.atLeave}
            atActive={transStyle.atActive}
            className="App-switch-wrapper"
          >
            {routes.map(({ path, Component }) => (
              <Route exact key={path} path={path} component={Component} />
            ))}
            <Route path='/' component={NotFound} />
          </AnimatedSwitch>
        </Router>
      </AppContext.Provider>
    </div>
  );
};

export default App;
